import { getDomain } from '@/utils/getApiDomain';

import { request } from './request';

// cos密钥类型
export enum StsType {
  CI = 2, // 数据万象（媒体处理）

  COS = 99, // 正常COS上传，仅前端用
}

/**
 *  获取cos临时密钥
*/
export const getCos = async (
  path: string,
  stsType?: StsType,
) => {
  const URL = `${getDomain()}/nova/outline/v1/get_cos_sts?path=${path}${stsType ? `&sts_type=${stsType}` : ''}`;
  const res = await request<{
    code: number;
    message: string;
    data: {
      Credentials: {
        TmpSecretId: string;
        TmpSecretKey: string;
        Token: string;
      };
      ExpiredTime: number;
      Expiration: string;
      StartTime: number;
      RequestId: string;
    };
  }>(`${URL}`, {
    method: 'GET',
  });
  return res;
};
